import { BRAND_VALUE_FILTER_TYPE, buildFilterKey } from "@faire/retailer-shared/filters/filterKeys";
import { BRAND_ATTRIBUTES } from "@faire/retailer-visitor-shared/consts/makerFilterValues";
import { MadeInAustralia, MadeInCanada, MadeInEurope, MadeInEuropeanCountry, MadeInUSA } from "@faire/retailer-visitor-shared/icons/MadeInCountry/MadeInCountry";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web--source/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import { Earn } from "@faire/web--source/slate/icons/foundation/Earn";
import { EcoFriendly } from "@faire/web--source/slate/icons/foundation/illustrations/EcoFriendly";
import { Handmade } from "@faire/web--source/slate/icons/foundation/illustrations/Handmade";
import { MadeLocally } from "@faire/web--source/slate/icons/foundation/illustrations/MadeLocally";
import { NotSoldOnAmazon } from "@faire/web--source/slate/icons/foundation/illustrations/NotSoldOnAmazon";
import { Organic } from "@faire/web--source/slate/icons/foundation/illustrations/Organic";
import { SmallBatch } from "@faire/web--source/slate/icons/foundation/illustrations/SmallBatch";
import { SocialGood } from "@faire/web--source/slate/icons/foundation/illustrations/SocialGood";
import { WomanOwned } from "@faire/web--source/slate/icons/foundation/illustrations/WomanOwned";
export var BRAND_VALUES = function(strictLocalize) {
    return {
        made_in_usa: {
            key: BRAND_ATTRIBUTES.MADE_IN_USA,
            label: strictLocalize({
                id: "XIM1Sx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in USA"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_USA),
            icon: MadeInUSA,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.USA
        },
        made_in_canada: {
            key: BRAND_ATTRIBUTES.MADE_IN_CANADA,
            label: strictLocalize({
                id: "wRpuHo",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Canada"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_CANADA),
            icon: MadeInCanada,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN
        },
        made_in_europe: {
            key: BRAND_ATTRIBUTES.MADE_IN_EUROPE,
            label: strictLocalize({
                id: "3Mce/w",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Europe"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_EUROPE),
            icon: MadeInEurope
        },
        made_in_uk: {
            key: BRAND_ATTRIBUTES.MADE_IN_UK,
            label: strictLocalize({
                id: "uiJ/Hh",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in UK"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_UK),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.GBR
        },
        made_in_germany: {
            key: BRAND_ATTRIBUTES.MADE_IN_GERMANY,
            label: strictLocalize({
                id: "ouptuc",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Germany"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_GERMANY),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.DEU
        },
        made_in_france: {
            key: BRAND_ATTRIBUTES.MADE_IN_FRANCE,
            label: strictLocalize({
                id: "xtMzEo",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in France"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_FRANCE),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.FRA
        },
        made_in_netherlands: {
            key: BRAND_ATTRIBUTES.MADE_IN_NETHERLANDS,
            label: strictLocalize({
                id: "gASbTV",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Netherlands"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_NETHERLANDS),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.NLD
        },
        made_in_italy: {
            key: BRAND_ATTRIBUTES.MADE_IN_ITALY,
            label: strictLocalize({
                id: "G//1fh",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Italy"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_ITALY),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.ITA
        },
        made_in_spain: {
            key: BRAND_ATTRIBUTES.MADE_IN_SPAIN,
            label: strictLocalize({
                id: "42XUEV",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Spain"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_SPAIN),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.ESP
        },
        made_in_austria: {
            key: BRAND_ATTRIBUTES.MADE_IN_AUSTRIA,
            label: strictLocalize({
                id: "p0ZywC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Austria"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_AUSTRIA),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.AUT
        },
        made_in_belgium: {
            key: BRAND_ATTRIBUTES.MADE_IN_BELGIUM,
            label: strictLocalize({
                id: "dXvZS1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Belgium"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_BELGIUM),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.BEL
        },
        made_in_denmark: {
            key: BRAND_ATTRIBUTES.MADE_IN_DENMARK,
            label: strictLocalize({
                id: "16J6f/",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Denmark"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_DENMARK),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.DNK
        },
        made_in_finland: {
            key: BRAND_ATTRIBUTES.MADE_IN_FINLAND,
            label: strictLocalize({
                id: "C4Xnkw",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Finland"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_FINLAND),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.FIN
        },
        made_in_ireland: {
            key: BRAND_ATTRIBUTES.MADE_IN_IRELAND,
            label: strictLocalize({
                id: "Qp6fFs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Ireland"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_IRELAND),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.IRL
        },
        made_in_luxembourg: {
            key: BRAND_ATTRIBUTES.MADE_IN_LUXEMBOURG,
            label: strictLocalize({
                id: "bn6TMX",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Luxembourg"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_LUXEMBOURG),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.LUX
        },
        made_in_norway: {
            key: BRAND_ATTRIBUTES.MADE_IN_NORWAY,
            label: strictLocalize({
                id: "Mh9983",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Norway"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_NORWAY),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.NOR
        },
        made_in_sweden: {
            key: BRAND_ATTRIBUTES.MADE_IN_SWEDEN,
            label: strictLocalize({
                id: "+3tD+U",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Sweden"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_SWEDEN),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.SWE
        },
        made_in_switzerland: {
            key: BRAND_ATTRIBUTES.MADE_IN_SWITZERLAND,
            label: strictLocalize({
                id: "4zPqN1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Switzerland"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_SWITZERLAND),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.CHE
        },
        made_in_portugal: {
            key: BRAND_ATTRIBUTES.MADE_IN_PORTUGAL,
            label: strictLocalize({
                id: "D+DI11",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Portugal"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_PORTUGAL),
            icon: MadeInEuropeanCountry,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.PRT
        },
        made_in_australia: {
            key: BRAND_ATTRIBUTES.MADE_IN_AUSTRALIA,
            label: strictLocalize({
                id: "h3gk49",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Made in Australia"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.MADE_IN_AUSTRALIA),
            icon: MadeInAustralia,
            countryISO: THREE_LETTER_PRIMARY_COUNTRY_CODES.AUS
        },
        shop_local: {
            key: BRAND_ATTRIBUTES.SHOP_LOCAL,
            label: strictLocalize({
                id: "xX+yil",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Shop local"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.SHOP_LOCAL),
            icon: MadeLocally
        },
        eco_friendly: {
            key: BRAND_ATTRIBUTES.ECO_FRIENDLY,
            label: strictLocalize({
                id: "SwTVss",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Eco-friendly"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.ECO_FRIENDLY),
            icon: EcoFriendly
        },
        hand_made: {
            key: BRAND_ATTRIBUTES.HAND_MADE,
            label: strictLocalize({
                id: "5Yoioh",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Handmade"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.HAND_MADE),
            icon: Handmade
        },
        gives_back: {
            key: BRAND_ATTRIBUTES.GIVES_BACK,
            label: strictLocalize({
                id: "YFrR/5",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Gives back"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.GIVES_BACK),
            icon: SocialGood
        },
        /**
     * @deprecated Use GIVES_BACK instead.
     */ charitable: {
            key: BRAND_ATTRIBUTES.CHARITABLE,
            label: strictLocalize({
                id: "FbCCPp",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Social good"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.CHARITABLE),
            icon: SocialGood
        },
        not_sold_on_amazon: {
            key: BRAND_ATTRIBUTES.NOT_SOLD_ON_AMAZON,
            label: strictLocalize({
                id: "aauh4e",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Not on Amazon"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.NOT_SOLD_ON_AMAZON),
            icon: NotSoldOnAmazon
        },
        organic: {
            key: BRAND_ATTRIBUTES.ORGANIC,
            label: strictLocalize({
                id: "j9p4Lh",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Organic"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.ORGANIC),
            icon: Organic
        },
        women_owned: {
            key: BRAND_ATTRIBUTES.WOMEN_OWNED,
            label: strictLocalize({
                id: "wpmTU5",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Women owned"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.WOMEN_OWNED),
            icon: WomanOwned
        },
        /**
     * @deprecated no direct replacement, avoid using.
     */ small_batch: {
            key: BRAND_ATTRIBUTES.SMALL_BATCH,
            label: strictLocalize({
                id: "PRbvmW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Small batch"
                    }
                ]
            }),
            value: buildFilterKey(BRAND_VALUE_FILTER_TYPE, BRAND_ATTRIBUTES.SMALL_BATCH),
            icon: SmallBatch
        },
        low_minimum: {
            key: BRAND_ATTRIBUTES.LOW_MINIMUM,
            label: strictLocalize({
                id: "/V/V9Z",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Low minimum"
                    }
                ]
            }),
            value: "".concat(BRAND_ATTRIBUTES.LOW_MINIMUM),
            icon: Earn
        }
    };
};
var BRAND_VALUES_ICON_MAP = function(strictLocalize) {
    return Object.values(BRAND_VALUES(strictLocalize)).reduce(function(acc, entry) {
        acc[entry.value] = entry.icon;
        return acc;
    }, {});
};
export var getBrandValueIcon = function(filterKey, strictLocalize) {
    var isLowMinimumFilter = filterKey.startsWith("maker_minimum:");
    var BrandValueIcon = BRAND_VALUES_ICON_MAP(strictLocalize)[isLowMinimumFilter ? BRAND_ATTRIBUTES.LOW_MINIMUM : filterKey];
    return BrandValueIcon;
};
